// src/lib/asArray.js
export const asArray = (v) => (Array.isArray(v) ? v : []);
